/* Golden Effect theme, ontwikkeld door elevatebyek */
(function () {
  'use strict';
  var GE = window.GE || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 760px)');

  /* ---------- geld ---------- */
  function money(cents) {
    var f = GE.moneyFormat || '€{{amount_with_comma_separator}}';
    cents = Math.round(cents);
    function fmt(n, d, t, dec) {
      var s = (n / 100).toFixed(d);
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p.length > 1 ? p[0] + dec + p[1] : p[0];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, '.', ',');
      }
    });
  }
  function points(cents) { return Math.floor(cents / 100 * (GE.pointsPerEuro || 5)); }

  /* ---------- panelen (menu, winkelmand, pop-up) ---------- */
  var lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('open'); });
    document.documentElement.classList.add('ge-lock');
    var f = el.querySelector('[data-menu-close], [data-cart-close], [data-pop-close], button, a');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closePanel(el) {
    if (!el || el.hidden) return;
    el.classList.remove('open');
    el.hidden = true;
    if (!$('.drawer.open, .cart.open, .pop.open')) document.documentElement.classList.remove('ge-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function trap(e, el) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, summary', el).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  document.addEventListener('keydown', function (e) {
    var open = $('.drawer.open, .cart.open, .pop.open');
    if (!open) return;
    if (e.key === 'Escape') { closePanel(open); setBurger(false); }
    else trap(e, open);
  });

  /* ---------- menu ---------- */
  function setBurger(v) { $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { e.preventDefault(); if (window.matchMedia('(min-width:1025px)').matches) { $$('[data-menu] details.m-sec').forEach(function (d) { d.open = true; }); } openPanel($('[data-menu]')); setBurger(true); return; }
    if (t.closest('[data-menu-close]')) { e.preventDefault(); closePanel($('[data-menu]')); setBurger(false); return; }
    if (t.closest('[data-cart-open]') && !document.body.classList.contains('ge-t-cart')) {
      e.preventDefault(); closePanel($('[data-menu]')); setBurger(false); openPanel($('[data-cart]')); return;
    }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closePanel($('[data-cart]')); return; }
    if (t.closest('[data-pop-close]')) { e.preventDefault(); closePop(); return; }
    var chat = t.closest('[data-chat]');
    if (chat && openInbox()) { e.preventDefault(); closePanel($('[data-menu]')); setBurger(false); return; }
    var add = t.closest('[data-add]');
    if (add) { e.preventDefault(); addItems([{ id: +add.getAttribute('data-add'), quantity: 1 }], add); return; }
    var line = t.closest('[data-line]');
    if (line) { e.preventDefault(); changeLine(+line.getAttribute('data-line'), +line.getAttribute('data-qty'), line); return; }
  });

  /* ---------- Golden Advice: Shopify Inbox chat openen ---------- */
  function openInbox() {
    var el = document.querySelector('inbox-online-store-chat, #ShopifyChat, shopify-chat');
    if (!el) return false;
    try { if (typeof el.show === 'function') { el.show(); return true; } } catch (err) {}
    try {
      var root = el.shadowRoot || el;
      var btn = root.querySelector('button.chat-toggle, button[aria-label*="hat"], button');
      if (btn) { btn.click(); return true; }
    } catch (err) {}
    return false;
  }

  /* ---------- winkelmand ---------- */
  function refreshCart(open) {
    return fetch((GE.routes.root || '/') + '?sections=ge-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['ge-cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart]');
        var cur = $('[data-cart]');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          var n = fresh.getAttribute('data-count');
          cur.setAttribute('data-count', n);
          $$('[data-cart-count]').forEach(function (c) { c.textContent = n; });
          $$('.bag').forEach(function (b) { b.setAttribute('aria-label', 'Winkelmand, ' + n + ' producten'); });
        }
        if (open) openPanel(cur);
        if (window.GE.cartPoints) window.GE.cartPoints();
      });
  }
  function toast(msg) {
    var t = $('.ge-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ge-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 4000);
  }
  function busy(el, on) { if (el) { el.classList.toggle('is-busy', on); if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy'); } }
  function addItems(items, btn, errEl) {
    busy(btn, true);
    return fetch(GE.routes.cartAdd + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        busy(btn, false);
        if (!res.ok) {
          var msg = res.j.description || res.j.message || 'Dit kon niet worden toegevoegd.';
          if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else toast(msg);
          return;
        }
        if (errEl) errEl.hidden = true;
        if (document.body.classList.contains('ge-t-cart')) { location.reload(); return; }
        return refreshCart(true);
      }).catch(function () { busy(btn, false); });
  }
  function changeLine(line, qty, el) {
    busy(el, true);
    fetch(GE.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function () {
      if (document.body.classList.contains('ge-t-cart')) location.reload();
      else refreshCart(false);
    });
  }
  document.addEventListener('change', function (e) {
    var qi = e.target.closest('.c-qi');
    if (qi) {
      var lines = $$('.c-qi');
      changeLine(lines.indexOf(qi) + 1, parseInt(qi.value, 10) || 0, qi);
    }
    var sort = e.target.closest('[data-ge-sort] select');
    if (sort) sort.form.submit();
  });

  /* ---------- aankondigingsbalk: één bericht op mobiel ---------- */
  $$('[data-ge-announce]').forEach(function (bar) {
    var items = $$('.ann-track > span:not([aria-hidden])', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (!mobile.matches || reduce) return;
      items[i].classList.remove('on');
      i = (i + 1) % items.length;
      items[i].classList.add('on');
    }, 4000);
  });

  /* ---------- hero slider ---------- */
  $$('[data-ge-slider]').forEach(function (sl) {
    var slides = $$('.slide', sl), dots = $$('.dots button', sl);
    if (slides.length < 2) return;
    var i = 0, timer = null, ms = +sl.getAttribute('data-interval') || 5000;
    function go(n) {
      slides[i].classList.remove('on'); if (dots[i]) dots[i].setAttribute('aria-selected', 'false');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('on'); if (dots[i]) dots[i].setAttribute('aria-selected', 'true');
      $$('img[loading=lazy]', slides[i]).forEach(function (im) { im.loading = 'eager'; });
    }
    function play() { stop(); if (!reduce) timer = setInterval(function () { go(i + 1); }, ms); sl.classList.remove('paused'); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
    sl.addEventListener('mouseenter', function () { stop(); sl.classList.add('paused'); });
    sl.addEventListener('mouseleave', play);
    sl.addEventListener('focusin', function () { stop(); sl.classList.add('paused'); });
    var x0 = null;
    sl.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    sl.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); }
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    document.addEventListener('shopify:block:select', function (e) {
      var n = slides.indexOf(e.target); if (n > -1) { go(n); stop(); }
    });
    play();
  });

  /* ---------- pop-up ---------- */
  var pop = $('[data-ge-pop]');
  function closePop() {
    if (!pop) return;
    closePanel(pop);
    try { localStorage.setItem('ge-pop', String(Date.now())); } catch (e) {}
  }
  if (pop) {
    var success = $('[data-pop-success]', pop);
    var days = +pop.getAttribute('data-days') || 14;
    var seen = 0;
    try { seen = +localStorage.getItem('ge-pop') || 0; } catch (e) {}
    var hidePages = /ge-t-cart|ge-t-password/.test(document.body.className);
    if (success) openPanel(pop);
    else if (!pop.hasAttribute('data-design') && !hidePages && Date.now() - seen > days * 864e5) {
      setTimeout(function () { if (!$('.drawer.open, .cart.open')) openPanel(pop); }, (+pop.getAttribute('data-delay') || 6) * 1000);
    }
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(pop)) openPanel(pop); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(pop)) closePanel(pop); });
  }

  /* ---------- aanmelden: direct naar Klaviyo (anders Shopify-klanten) ---------- */
  document.addEventListener('submit', function (e) {
    var wrap = e.target.closest('[data-ge-signup]');
    if (!wrap || !wrap.getAttribute('data-klaviyo-list')) return;
    e.preventDefault();
    var form = e.target, input = form.querySelector('input[type=email]');
    var err = wrap.querySelector('[data-signup-error]'), ok = wrap.querySelector('[data-signup-success]'), step = wrap.querySelector('[data-signup-step]');
    var btn = form.querySelector('[type=submit]');
    var email = (input.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { if (err) { err.textContent = 'Vul een geldig e-mailadres in.'; err.hidden = false; } return; }
    busy(btn, true);
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(wrap.getAttribute('data-klaviyo-key')), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: wrap.getAttribute('data-source') || 'Website',
        profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
      }, relationships: { list: { data: { type: 'list', id: wrap.getAttribute('data-klaviyo-list') } } } } })
    }).then(function (r) {
      busy(btn, false);
      if (!r.ok) throw new Error(r.status);
      if (err) err.hidden = true;
      if (step) step.hidden = true;
      if (ok) ok.hidden = false;
      if (!step) input.value = '';
      try { localStorage.setItem('ge-pop', String(Date.now() + 3650 * 864e5)); } catch (x) {}
    }).catch(function () {
      busy(btn, false);
      if (err) { err.textContent = 'Aanmelden lukte niet. Probeer het later nog eens.'; err.hidden = false; }
    });
  });

  /* ---------- video's: pas laden en spelen in beeld ---------- */
  function loadVideo(v) {
    if (v.getAttribute('data-src') && !v.src) { v.src = v.getAttribute('data-src'); v.load(); }
  }
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          loadVideo(v);
          if (!reduce && v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused && v.muted) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    $$('video[data-src]').forEach(function (v) { vio.observe(v); });
  } else {
    $$('video[data-src]').forEach(loadVideo);
  }

  /* ---------- aanbevelingen ---------- */
  $$('[data-ge-reco]').forEach(function (box) {
    if (box.children.length) return;
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g = doc.querySelector('[data-ge-reco]');
      if (g && g.innerHTML.trim()) box.innerHTML = g.innerHTML;
      else { var s = box.closest('section'); if (s) s.hidden = true; }
    });
  });

  /* ---------- FAQ: meer tonen ---------- */
  $$('[data-faq-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var wrap = b.closest('[data-ge-faq]');
      var more = $$('[data-more]', wrap);
      var show = more.length && more[0].hidden;
      more.forEach(function (d) { d.hidden = !show; });
      b.textContent = show ? 'Minder vragen' : b.getAttribute('data-more-label');
      b.setAttribute('aria-expanded', show ? 'true' : 'false');
    });
  });

  /* ---------- tabbladen (FAQ-pagina) ---------- */
  $$('[data-ge-tabs]').forEach(function (w) {
    var tabs = $$('[role=tab]', w);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      });
    });
  });

  /* ---------- verzendtijd (Amsterdamse tijd) ---------- */
  function amsNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return { day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday), h: +o.hour % 24, m: +o.minute };
    } catch (e) { var d = new Date(); return { day: d.getDay(), h: d.getHours(), m: d.getMinutes() }; }
  }
  function cutoff() {
    var n = amsNow(), c = GE.cutoffHour || 16;
    $$('[data-cutoff]').forEach(function (el) {
      if (n.day > 0 && n.day < 6 && n.h < c) {
        var left = c * 60 - (n.h * 60 + n.m);
        var h = Math.floor(left / 60), m = left % 60;
        el.innerHTML = 'Bestel binnen <b>' + (h ? h + ' uur en ' : '') + m + ' min</b>, dan versturen we vandaag nog';
      } else {
        el.textContent = 'Bestel nu, dan versturen we het de volgende werkdag';
      }
    });
  }
  if ($('[data-cutoff]')) { cutoff(); setInterval(cutoff, 60000); }

  /* ---------- productpagina ---------- */
  $$('[data-ge-product]').forEach(function (root) {
    var form = $('[data-ge-form]', root);
    var jsonEl = $('[data-product-json]', root);
    if (!form || !jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = $('[data-variant-input]', form);
    var qtyInput = $('[data-qty-input]', form);
    var addBtn = $('[data-add-btn]', form);
    var addLabel = $('[data-add-label]', form);
    var errEl = $('[data-form-error]', form);
    var current = product.variants.filter(function (v) { return v.id === +idInput.value; })[0] || product.variants[0];

    function qty() { return Math.max(1, parseInt(qtyInput.value, 10) || 1); }
    var deal = $('[data-deal]', form);
    var dealQty = deal ? +deal.getAttribute('data-deal-qty') : 0;
    var dealPct = deal ? +deal.getAttribute('data-deal-pct') : 0;
    function lineTotal(v, q) {
      var t = v.price * q;
      return dealQty > 1 && q >= dealQty ? Math.round(t * (100 - dealPct) / 100) : t;
    }
    function renderDeal(v, q) {
      if (!deal) return;
      var was = v.price * dealQty, now = lineTotal(v, dealQty);
      $$('[data-deal-one]', deal).forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-deal-now]', deal).forEach(function (el) { el.textContent = money(now); });
      $$('[data-deal-was]', deal).forEach(function (el) { el.textContent = money(was); });
      $$('[data-deal-each]', deal).forEach(function (el) { el.textContent = money(Math.round(now / dealQty)); });
      $$('[data-deal-save]', deal).forEach(function (el) { el.textContent = money(was - now); });
      $$('[data-deal-radio]', deal).forEach(function (r) { r.checked = (+r.value === dealQty) ? q >= dealQty : q === 1; });
    }
    if (deal) $$('[data-deal-radio]', deal).forEach(function (r) {
      r.addEventListener('change', function () { qtyInput.value = r.value; render(); });
    });
    function render() {
      var v = current, q = qty();
      renderDeal(v, q);
      idInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? 'In winkelmand · ' + money(lineTotal(v, q)) : 'Tijdelijk uitverkocht';
      }
      $$('[data-price]', root).forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-was]', root).forEach(function (el) { el.hidden = !(v.compare_at_price > v.price); });
      $$('[data-was-price]', root).forEach(function (el) { el.textContent = money(v.compare_at_price || 0); });
      $$('[data-save]', root).forEach(function (el) { el.textContent = money((v.compare_at_price || 0) - v.price); });
      $$('[data-klarna]', root).forEach(function (el) { el.textContent = money(lineTotal(v, q) / 3); });
      $$('[data-points]', root).forEach(function (el) { el.textContent = points(lineTotal(v, q)); });
      $$('[data-sticky-price]').forEach(function (el) { el.textContent = money(v.price); });
    }
    function setVariant(v, fromUser) {
      if (!v) return;
      current = v; render();
      if (fromUser && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
      if (v.featured_media) {
        var g = $('[data-gallery]', root), slide = $('[data-media-id="' + v.featured_media.id + '"]', root);
        if (slide && g) g.scrollTo({ left: Array.prototype.indexOf.call(g.children, slide) * g.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    $$('[data-variant-radio]', form).forEach(function (r) {
      r.addEventListener('change', function () {
        setVariant(product.variants.filter(function (v) { return v.id === +r.value; })[0], true);
      });
    });
    $$('[data-option-radio]', form).forEach(function (r) {
      r.addEventListener('change', function () {
        var sel = $$('fieldset[data-option-index]', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var v = product.variants.filter(function (x) { return x.options.every(function (o, n) { return o === sel[n]; }); })[0];
        if (v) setVariant(v, true);
        else if (addBtn) { addBtn.disabled = true; addLabel.textContent = 'Niet beschikbaar'; }
      });
    });
    $('[data-qty-minus]', form).addEventListener('click', function () { qtyInput.value = Math.max(1, qty() - 1); render(); });
    $('[data-qty-plus]', form).addEventListener('click', function () { qtyInput.value = Math.min(20, qty() + 1); render(); });
    qtyInput.addEventListener('change', render);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addItems([{ id: current.id, quantity: qty() }], addBtn, errEl);
    });

    /* galerij: grote foto met thumbnails, pijlen en stipjes */
    var gal = $('[data-gallery]', root), cnt = $('[data-gal-count]', root);
    var thumbs = $$('[data-thumb]', root), dots = $$('.gal-dots i', root);
    function galIndex() { return gal ? Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)) : 0; }
    function galGo(i) {
      if (!gal) return;
      var n = gal.children.length; i = (i + n) % n;
      gal.scrollTo({ left: i * gal.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    function galSync() {
      var i = Math.min(galIndex(), gal.children.length - 1);
      if (cnt) cnt.textContent = (i + 1) + ' / ' + gal.children.length;
      thumbs.forEach(function (t, n) { t.classList.toggle('on', n === i); if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
    }
    if (gal) {
      gal.addEventListener('scroll', function () { clearTimeout(gal._t); gal._t = setTimeout(galSync, 60); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { galGo(+t.getAttribute('data-thumb')); }); });
      var pv = $('[data-gal-prev]', root), nx = $('[data-gal-next]', root);
      if (pv) pv.addEventListener('click', function () { galGo(galIndex() - 1); });
      if (nx) nx.addEventListener('click', function () { galGo(galIndex() + 1); });
      gal.setAttribute('tabindex', '0');
      gal.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') galGo(galIndex() + 1); if (e.key === 'ArrowLeft') galGo(galIndex() - 1); });
    }

    /* vaste koopbalk zodra de knop uit beeld is */
    var sticky = $('[data-sticky-buy]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (en) {
        var e0 = en[0];
        var past = !e0.isIntersecting && e0.boundingClientRect.top < 0;
        sticky.classList.toggle('show', past);
        document.body.classList.toggle('sticky-on', past);
      }).observe(addBtn);
    }
    render();
  });

  /* ---------- routine-bouwer ---------- */
  $$('[data-ge-builder]').forEach(function (b) {
    function items() {
      return $$('input[type=checkbox][data-b-id]', b).filter(function (i) { return i.checked; });
    }
    var sets = [];
    try { sets = JSON.parse(($('[data-b-sets]', b) || {}).textContent || '[]').filter(Boolean); } catch (err) {}
    function matchSet() {
      var ids = items().map(function (i) { return +i.getAttribute('data-b-id'); }).sort();
      if (ids.length < 2) return null;
      for (var k = 0; k < sets.length; k++) {
        var s = sets[k].items.slice().sort();
        if (s.length === ids.length && s.every(function (v, n) { return v === ids[n]; })) return sets[k];
      }
      return null;
    }
    function calc() {
      var sum = items().reduce(function (s, i) { return s + (+i.getAttribute('data-b-price')); }, 0);
      var set = matchSet(), total = set ? set.price : sum;
      var t = $('[data-b-total]', b), p = $('[data-b-pts]', b), w = $('[data-b-was]', b), n = $('[data-b-set]', b);
      if (t) t.textContent = money(total);
      if (p) p.textContent = '+' + points(total) + ' Golden Points';
      if (w) { var show = set && sum > set.price; w.hidden = !show; w.textContent = show ? money(sum) : ''; }
      if (n) { n.hidden = !set; n.textContent = set ? (n.getAttribute('data-b-set-text') || '') + ' ' + set.title : ''; }
    }
    b.addEventListener('change', calc);
    $$('[data-b-pick]', b).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var row = btn.closest('.b-item');
        $$('[data-b-pick]', row).forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
        var cb = $('input[type=checkbox]', row);
        cb.setAttribute('data-b-id', btn.getAttribute('data-b-pick'));
        cb.setAttribute('data-b-price', btn.getAttribute('data-b-price'));
        var pr = $('[data-b-p]', row); if (pr) pr.textContent = money(+btn.getAttribute('data-b-price'));
        row.classList.toggle('alt', btn !== $('[data-b-pick]', row));
        cb.checked = true; calc();
      });
    });
    var add = $('[data-b-add]', b);
    if (add) add.addEventListener('click', function () {
      var set = matchSet();
      var list = set ? [{ id: set.id, quantity: 1 }] : items().map(function (i) { return { id: +i.getAttribute('data-b-id'), quantity: 1 }; });
      if (list.length) addItems(list, add);
    });
    calc();
  });

  /* ---------- Golden Points (Yotpo Loyalty): saldo, voortgang en inwisselen ---------- */
  var gpPts = null, gpOpts = null;
  function nl(n) { return Number(n).toLocaleString('nl-NL'); }
  function optPoints(o) {
    if (!o) return null;
    var n = o.amount != null ? o.amount : (o.pointsRequired != null ? o.pointsRequired : null);
    if (n == null && o.costText) n = parseInt(String(o.costText).replace(/[^0-9]/g, ''), 10);
    return n == null || isNaN(n) ? null : +n;
  }
  function loadOpts() {
    var api = window.swellAPI;
    if (gpOpts || !api || !api.getActiveRedemptionOptions) return gpOpts;
    try { gpOpts = (api.getActiveRedemptionOptions() || []).filter(function (o) { return optPoints(o) > 0; }); } catch (e) { gpOpts = null; }
    return gpOpts;
  }
  function paintRewards(pts) {
    var rws = $$('[data-reward]'), next = null;
    rws.forEach(function (rw) {
      var cost = +rw.getAttribute('data-reward'), need = cost - pts, btn = $('[data-reward-btn]', rw);
      rw.classList.toggle('can', need <= 0);
      if (need > 0 && (next === null || cost < next)) next = cost;
      if (!btn || btn.tagName !== 'BUTTON') return;
      if (need > 0) { btn.textContent = 'Nog ' + nl(need) + ' punten'; btn.disabled = true; btn.classList.add('ghost'); }
      else { btn.textContent = 'Inwisselen'; btn.disabled = false; btn.classList.remove('ghost'); }
    });
    var prog = $('[data-gp-prog]'), st = $('[data-gp-status]');
    if (prog) {
      var goal = next || (rws.length ? +rws[rws.length - 1].getAttribute('data-reward') : 0);
      if (goal) {
        var pct = Math.max(0, Math.min(100, Math.round(pts / goal * 100)));
        var reward = $('[data-reward="' + goal + '"] b');
        $('[data-gp-prog-text]', prog).textContent = next ? 'Nog ' + nl(goal - pts) + ' punten tot ' + (reward ? reward.textContent : 'je volgende reward') : 'Je kunt al je rewards inwisselen';
        $('[data-gp-prog-pct]', prog).textContent = pct + '%';
        $('.gp-bar i', prog).style.width = pct + '%';
        $('.gp-bar', prog).setAttribute('aria-valuenow', pct);
        prog.hidden = false;
      }
    }
    var first = +(($('[data-ge-loyalty]') || { getAttribute: function () { return 0; } }).getAttribute('data-first-reward') || 0);
    if (st) st.innerHTML = 'Je hebt <b>' + nl(pts) + '</b> Golden Points. ' + (pts < first ? 'Spaar nog even door voor je eerste korting.' : 'Wissel ze hieronder in voor korting.');
  }
  function fillLoyalty() {
    var api = window.swellAPI;
    if (!api || !api.getCustomerDetails) return false;
    var c;
    try { c = api.getCustomerDetails(); } catch (e) { return false; }
    if (!c) return false;
    var pts = c.pointsBalance != null ? c.pointsBalance : c.points_balance;
    if (pts == null) return false;
    gpPts = +pts;
    $$('[data-yotpo-points]').forEach(function (el) { el.textContent = nl(gpPts); });
    var tier = c.vipTier || c.vip_tier;
    if (tier && tier.name) $$('[data-yotpo-tier]').forEach(function (el) { el.textContent = tier.name; });
    paintRewards(gpPts);
    loadOpts();
    cartPoints();
    return true;
  }
  if ($('[data-ge-loyalty]') || $('[data-yotpo-points]')) {
    document.addEventListener('swell:setup', fillLoyalty);
    if (!fillLoyalty()) {
      var tries = 0, iv = setInterval(function () {
        if (fillLoyalty() || ++tries > 24) {
          clearInterval(iv);
          if (gpPts === null) {
            $$('[data-yotpo-points]').forEach(function (el) { if (el.textContent.trim() === '…') el.textContent = el.getAttribute('data-fallback') === '…' ? '–' : (el.getAttribute('data-fallback') || '–'); });
            $$('button[data-reward-btn]').forEach(function (b) { b.textContent = 'Probeer later opnieuw'; });
          }
        }
      }, 500);
    }
  }
  /* winkelmand: saldo tonen en punten inwisselen voor een kortingscode */
  function cartPoints() {
    if (gpPts === null) return;
    var opts = (loadOpts() || []).filter(function (o) { return optPoints(o) <= gpPts; }).sort(function (a, b) { return optPoints(b) - optPoints(a); });
    $$('[data-cart-gp]').forEach(function (box) {
      var bal = $('[data-gp-bal]', box), red = $('[data-gp-redeem]', box), sel = $('[data-gp-opt]', box);
      if (bal) { $('[data-yotpo-points]', bal).textContent = nl(gpPts); bal.hidden = false; }
      if (!red || !sel) return;
      if (!opts.length) { red.hidden = true; return; }
      sel.innerHTML = opts.map(function (o) { return '<option value="' + o.id + '">' + (o.name || '').replace(/ off$/i, ' korting') + ' voor ' + nl(optPoints(o)) + ' punten</option>'; }).join('');
      red.hidden = false;
    });
  }
  window.GE.cartPoints = cartPoints;
  function applyCode(code) {
    return fetch((GE.routes.root || '/') + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code }) })
      .catch(function () {})
      .then(function () { return fetch((GE.routes.root || '/') + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gp-apply]'); if (!b) return;
    var box = b.closest('[data-cart-gp]'), sel = $('[data-gp-opt]', box), msg = $('[data-gp-msg]', box), api = window.swellAPI;
    if (!api || !sel || !sel.value) return;
    b.disabled = true; b.textContent = 'Bezig…';
    redeem(+sel.value, function (red) {
      var code = red && (red.couponCode || red.coupon_code || (red.coupon && red.coupon.code));
      if (!code) { b.disabled = false; b.textContent = 'Inwisselen'; return; }
      applyCode(code).then(function () {
        toast('Je korting is toegepast (code ' + code + ')');
        gpOpts = null;
        if (box.closest('[data-cart]')) { refreshCart(); setTimeout(fillLoyalty, 1500); }
        else location.reload();
      });
    }, function (err) {
      b.disabled = false; b.textContent = 'Inwisselen';
      if (msg) { msg.textContent = failText(err); msg.hidden = false; }
    });
  });
  /* verzoeken naar Yotpo bijhouden, zodat we een duidelijke foutmelding kunnen geven */
  var gpLast = null;
  (function () {
    var op = XMLHttpRequest.prototype.open, sd = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this._gpUrl = u; return op.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (x._gpUrl && /point_redemptions|referral/i.test(x._gpUrl)) x.addEventListener('loadend', function () { gpLast = { url: x._gpUrl, status: x.status, body: (x.responseText || '').slice(0, 300) }; try { console.log('[Golden Points]', gpLast); } catch (e) {} });
      return sd.apply(this, arguments);
    };
  })();
  function redeem(optId, done, fail) {
    var api = window.swellAPI, finished = false;
    var t = setTimeout(function () { if (!finished) { finished = true; fail(gpLast); } }, 15000);
    try {
      api.makeRedemption({ redemptionOptionId: optId }, function (red) { if (finished) return; finished = true; clearTimeout(t); done(red); },
        function (err) { if (finished) return; finished = true; clearTimeout(t); fail(err || gpLast); });
    } catch (e) { finished = true; clearTimeout(t); fail({ message: String(e) }); }
  }
  function failText(err) {
    var st = err && err.status, m = err && (err.message || err.body);
    if (/enough/i.test(m || '')) return 'Je hebt niet genoeg punten voor deze korting.';
    return 'Inwisselen lukt nu niet' + (st ? ' (code ' + st + ')' : '') + '. Probeer het later opnieuw of stuur ons een bericht.';
  }
  /* vriendin uitnodigen: eigen link, WhatsApp en e-mail */
  function fillReferral() {
    var box = $('[data-gp-ref]'), api = window.swellAPI; if (!box || !api) return false;
    var link = '';
    try { link = (api.getCustomerShareReferralLink && api.getCustomerShareReferralLink('copy_link')) || (api.getCustomerDetails() || {}).referralLink || ''; } catch (e) {}
    if (!link) return false;
    link = link.replace(/^http:/, 'https:');
    $('[data-gp-ref-link]', box).value = link;
    var wa = link; try { wa = (api.getCustomerShareReferralLink('sms') || link).replace(/^http:/, 'https:'); } catch (e) {}
    $('[data-gp-ref-wa]', box).href = 'https://wa.me/?text=' + encodeURIComponent('Ik gebruik Golden Effect voor mijn haar en hoofdhuid. Met mijn link krijg je korting op je eerste bestelling: ' + wa);
    return true;
  }
  if ($('[data-gp-ref]')) {
    var rt = 0, rv = setInterval(function () {
      if (fillReferral()) clearInterval(rv);
      else if (++rt > 24) { clearInterval(rv); var fb = $('[data-gp-ref-fallback]'); if (fb) { fb.hidden = false; $$('.gp-ref-link, .gp-ref-share, .gp-ref-mail, [data-gp-ref] .lp-k').forEach(function (el) { el.hidden = true; }); } }
    }, 500);
    document.addEventListener('swell:setup', fillReferral);
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-gp-ref-copy]'); if (!c) return;
    var v = $('[data-gp-ref-link]').value;
    (navigator.clipboard ? navigator.clipboard.writeText(v) : Promise.reject()).then(function () { c.textContent = 'Gekopieerd'; setTimeout(function () { c.textContent = 'Kopieer'; }, 2000); }, function () { $('[data-gp-ref-link]').select(); });
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-gp-ref-form]'); if (!f) return;
    e.preventDefault();
    var inp = $('input[type=email]', f), msg = $('[data-gp-ref-msg]', f), btn = $('button', f), api = window.swellAPI;
    var mails = inp.value.split(/[\s,;]+/).filter(Boolean);
    if (!mails.length || !api || !api.sendReferralEmails) return;
    btn.disabled = true;
    api.sendReferralEmails(mails, function () { msg.textContent = 'Verstuurd! Bestelt ze, dan krijg jij je punten.'; msg.hidden = false; inp.value = ''; btn.disabled = false; },
      function (err) { msg.textContent = (err && err.message && !/valid email/i.test(err.message)) ? 'Versturen lukt nu niet. Deel je link liever via WhatsApp.' : 'Vul een geldig e-mailadres in.'; msg.hidden = false; btn.disabled = false; });
  });



  /* snelmenu: links naar secties die er niet zijn verbergen */
  $$('.subnav a[href^="#"]').forEach(function (a) { if (!document.getElementById(a.getAttribute('href').slice(1))) a.remove(); });
  /* resultaten: pijlen bij horizontaal scrollen */
  $$('[data-ba]').forEach(function (w) {
    var g = $('.ba-grid', w), prev = $('[data-ba-prev]', w), next = $('[data-ba-next]', w);
    if (!g || !prev) return;
    function step() { var c = g.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : g.clientWidth; }
    function upd() { prev.disabled = g.scrollLeft < 4; next.disabled = g.scrollLeft + g.clientWidth > g.scrollWidth - 4; }
    prev.addEventListener('click', function () { g.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { g.scrollBy({ left: step(), behavior: 'smooth' }); });
    g.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  });
  /* inwisselen */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-reward-btn]');
    if (!btn || btn.disabled) return;
    var rw = btn.closest('[data-reward]'), cost = +rw.getAttribute('data-reward'), api = window.swellAPI;
    var opt = (loadOpts() || []).filter(function (o) { return optPoints(o) === cost; })[0];
    if (!api || !opt) { btn.textContent = 'Lukt nu niet, probeer later'; return; }
    btn.disabled = true; btn.textContent = 'Bezig…';
    redeem(opt.id, function (red) {
      var code = red && (red.couponCode || red.coupon_code || (red.coupon && red.coupon.code));
      var box = $('[data-gp-code]');
      if (box && code) { $('[data-gp-code-val]', box).textContent = code; box.hidden = false; box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      btn.textContent = 'Ingewisseld';
      setTimeout(function () { gpOpts = null; fillLoyalty(); }, 1500);
    }, function (err) { btn.disabled = false; btn.textContent = 'Opnieuw proberen'; toast(failText(err)); });
  });
  document.addEventListener('click', function (e) {
    var cp = e.target.closest('[data-gp-copy]'); if (!cp) return;
    var v = $('[data-gp-code-val]').textContent;
    (navigator.clipboard ? navigator.clipboard.writeText(v) : Promise.reject()).then(function () { cp.textContent = 'Gekopieerd'; }, function () { cp.textContent = v; });
  });

  /* ---------- editor: panelen tonen bij selecteren ---------- */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart]')) openPanel($('[data-cart]'));
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-cart]')) closePanel($('[data-cart]'));
  });
})();

/* desktop hoofdmenu */
(function () {
  var nav = document.querySelector('[data-dnav]'); if (!nav) return;
  var items = [].slice.call(nav.querySelectorAll('.dn-item')), timer;
  var mq = window.matchMedia('(min-width:1025px)');
  function set(it, open) {
    items.forEach(function (x) {
      var o = open && x === it; x.classList.toggle('is-open', o);
      var b = x.querySelector('button.dn-top'); if (b) b.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
  }
  items.forEach(function (it) {
    var b = it.querySelector('button.dn-top'); if (!b) { it.addEventListener('mouseenter', function () { clearTimeout(timer); set(null, false); }); return; }
    b.addEventListener('click', function () { set(it, !it.classList.contains('is-open')); });
    it.addEventListener('mouseenter', function () { if (!mq.matches) return; clearTimeout(timer); timer = setTimeout(function () { set(it, true); }, 90); });
    it.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(function () { set(it, false); }, 160); });
    it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) set(it, false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return; var o = nav.querySelector('.dn-item.is-open'); if (!o) return;
    set(null, false); var b = o.querySelector('button.dn-top'); if (b) b.focus();
  });
  document.addEventListener('click', function (e) { if (!nav.contains(e.target)) set(null, false); });
})();


/* schuifrijen starten links met marge */
(function () {
  function reset() { document.querySelectorAll('.reels,.steps,.ba-grid,.grid.combo,.who,.creatives,.swipe').forEach(function (el) { if (el.scrollLeft && el.scrollLeft < 40) el.scrollLeft = 0; }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reset); else reset();
  window.addEventListener('load', reset);
})();
